export enum HomePageSections {
  CRAFTING = 'crafting',
  SEASON = 'season',
  FARMING = 'farming',
  REFERRAL = 'referral',
  BLOCKCHAIN = 'blockchain'
}

export const homePageSections: Record<
  HomePageSections,
  {
    title: string;
    description?: string;
    previewSrc?: HomePageSections;
    explanationSrc?: string;
  }
> = {
  [HomePageSections.CRAFTING]: {
    title: 'homePageHowCraftingWorks',
    description: 'homePageHowCraftingWorksDescription',
    previewSrc: HomePageSections.CRAFTING,
    explanationSrc: `${HomePageSections.CRAFTING}-explanation`
  },
  [HomePageSections.SEASON]: {
    title: 'homePageHowSeasonWorks',
    description: 'homePageHowSeasonWorksDescription',
    previewSrc: HomePageSections.SEASON,
    explanationSrc: `${HomePageSections.SEASON}-explanation`
  },
  [HomePageSections.FARMING]: {
    title: 'homePageHowFarmingWorks',
    description: 'homePageHowFarmingWorksDescription',
    previewSrc: HomePageSections.FARMING,
    explanationSrc: `${HomePageSections.FARMING}-explanation`
  },
  [HomePageSections.REFERRAL]: {
    title: 'homePageHowReferralWorks',
    description: 'howReferralWorksDescription',
    previewSrc: HomePageSections.REFERRAL,
    explanationSrc: `${HomePageSections.REFERRAL}-explanation`
  },
  [HomePageSections.BLOCKCHAIN]: {
    title: 'homePageHowBlockchainWorks'
  }
};
